(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/banner-type-quickplay/assets/javascripts/banner-type-quickplay.js') >= 0) return;  svs.modules.push('/components/content/banner-type-quickplay/assets/javascripts/banner-type-quickplay.js'); 
'use strict';

var globalQuickplayHasLoaded = false;
svs.content.bannerTypeQuickplay = {};

svs.content.bannerTypeQuickplay.init = function (options) {
  var bagType = svs.utils.paramHandler.get({
    key: 'bag'
  }).value;

  if (bagType) {
    var product = bagType.split('_')[0];
    var size = bagType.split('_').length > 1 && bagType.split('_')[1];
    loadModule({
      product: product,
      size: size
    });
  } 


  options.$el.off('click', '.js-quickplay-btn').on('click', '.js-quickplay-btn', payNow);
  new svs.components.ContentReveal({
    el: options.$el.find('.js-quickplay')
  });
  svs.components.Storage.browser.get('quickPlayGame', 'quickplay', function (storedQuickPlay) {
    if (!globalQuickplayHasLoaded && storedQuickPlay && Object.prototype.hasOwnProperty.call(storedQuickPlay, 'product') && Object.prototype.hasOwnProperty.call(storedQuickPlay, 'price')) {
      globalQuickplayHasLoaded = true;
      loadModule(storedQuickPlay);
    }
  });
};

function trackClick(el) {
  var $el = $(el);
  var track = $el.data('track');
  var areaName = $el.data('areaName') || 'unknown';

  if (track) {
    svs.components.analytics.trackPromoClick({
      id: track,
      name: track,
      position: areaName
    });
  }
}

function payNow(e) {
  trackClick(this);
  var $el = e.currentTarget;
  var options = {
    product: $el.dataset.product,
    price: $el.dataset.packageid,
    description: $el.dataset.description,
    productName: $el.dataset.productname
  };

  if ($el.dataset.drawnumber) {
    options.drawNumber = $el.dataset.drawnumber;
  }

  if ($el.dataset.drawid) {
    options.drawId = $el.dataset.drawid;
  }

  loadModule(options);
}

function loadModule(options) {
  var clPath;

  switch (options.product) {
    case 'lordagsgodis':
    case 'rubbet':
      clPath = '/cl/bags/bag-client';
      break;

    case 'extratipset':
    case 'europatipset':
    case 'stryktipset':
    case 'powerplay':
      clPath = '/cl/sport/tipset-xperten-widget';
      break;

    case 'topptipset':
    case 'topptipsetextra':
    case 'topptipsetstryk':
      clPath = '/cl/sport/topptipset-xperten-widget';
      break;

    case 'bomben':
      clPath = '/cl/sport/bomben-xperten-widget';
      break;

    case 'maltipset':
      clPath = '/cl/sport/maltipset-xperten-widget';
      break;

    case 'challenge':
    case 'TMIX':
      clPath = '/cl/sport/challenge-xperten-widget';
      break;

    default:
      clPath = '/cl/app/quickplay';
  }

  svs.components.loader.show();
  svs.core.module.load(clPath, null, function (error) {
    if (error) {
      svs.components.loader.hide();
      svs.components.Alert('Kunde inte ladda spelet - Försök igen!', {
        time: svs.components.Alert.Time.SHORT,
        type: svs.components.Alert.Type.ERROR
      }).show(null);
    } else {
      var hideLoader = true;

      switch (options.product) {
        case 'rubbet': 

        case 'lordagsgodis':
          {
            if (!options.size && Boolean(options.price)) {
              switch (options.price) {
                case '170':
                  options.size = 'medium';
                  break;

                case '240': 

                case '370':
                  options.size = 'large';
                  break;

                default:
                  options.size = 'small';
              }
            }

            svs.components.BagClient.init({
              bagFormat: options.product,
              size: options.size,
              hasTriss: options.product === 'lordagsgodis'
            });
            break;
          }

        case 'extratipset':
        case 'europatipset':
        case 'stryktipset':
        case 'powerplay':
          new svs.sport.tipset_xperten_widget.TipsetXpertenWidget({
            productId: options.productId,
            size: options.price,
            productName: options.productName
          }).show();
          break;

        case 'topptipset':
        case 'topptipsetextra':
        case 'topptipsetstryk':
          new svs.sport.topptipset_xperten_widget.TopptipsetXpertenWidget({
            size: options.price
          }).show();
          break;

        case 'bomben':
          new svs.sport.bomben_xperten_widget.BombenXpertenWidget({
            productId: options.productId,
            size: options.price,
            productName: options.productName,
            drawNumber: options.drawNumber
          }).show();
          break;

        case 'maltipset':
          new svs.sport.maltipset_xperten_widget.MaltipsetXpertenWidget({
            productId: options.productId,
            size: options.price,
            productName: options.productName
          }).show();
          break;

        case 'challenge':
        case 'TMIX':
          new svs.sport.challenge_xperten_widget.ChallengeXpertenWidget({
            productId: options.productId,
            size: options.price,
            productName: options.productName,
            drawNumber: options.drawNumber
          }).show();
          break;

        default:
          hideLoader = false;
          new svs.app.QuickPlay({
            options: options
          }).init();
      }

      if (hideLoader) {
        svs.components.loader.hide();
      }
    }
  }, false);
}
 })(window);